// ==============
// ==============
// ==============
// VERANSTALTUNGEN
// ==============
// ==============
// ==============

export const veranstaltungenData = {
  content: [
    {
      id: 1,
      text: `Sie planen ein Sommerfest, eine Firmenfeier oder ein anderes Event? Verpassen Sie Ihrem Event den letzten Schliff mit unseren vielseitigen Attraktionen!`,
    },
    {
      id: 2,
      text:
        "Egal ob Firmenevent, Geburtstag, Jubiläum oder Hochzeit, unser Eis schmeckt zu jeder Gelegenheit unvergleichbar gut. Mit Charlie und seinem Eiswagen zaubern Sie Ihren Gästen ein Lächeln ins Gesicht und ein leckeres Eis in die Hand.",
    },
    {
      id: 3,
      text:
        "Wir können Ihnen weitaus mehr bieten als einen originellen Eiswagen. Wir haben eine große Vielfalt von Veranstaltungsausstattung vom Kaffeewagen bis zum Zirkuszelt! Schauen Sie in unser Angebot und stellen Sie eine unverbindliche Anfrage. Wir helfen Ihnen gerne ein unvergessliches Event zu gestalten.",
    },
  ],
}

// ==============
// ==============
// ==============
// FAHRGESCHÄFTE
// ==============
// ==============
// ==============

export const fahrgeschaefte = {
  content: [
    {
      id: 0,
      state: false,
      title: "Eiswagen",
      img: "../images/fahrgeschaefte/eiswagen.png",
      text:
        "Nostalgische Kinderkarussells, als Highlight für ihr familienfreundliches Event. Zwei unterschiedliche Modelle: ein entzückendes Kettenkarussell, das Platz für 5 Kinder bietet und ein Tierkarussell für 7 Kinder.",
      information: [
        { id: 1, title: "Größe", value: "" },
        { id: 2, title: "Strombedarf", value: "" },
        {
          id: 3,
          title: "Preis",
          value:
            "ab 250 € zzgl. Anlieferung / Abholung // ca. 410,00 € inkl. MwSt.",
        },
      ],
      price: 150,
      gallery: [],
    },

    {
      id: 1,
      state: false,
      title: "Karussel",
      img: "../images/fahrgeschaefte/karussel.png",
      text:
        "Nostalgische Kinderkarussells, als Highlight für ihr familienfreundliches Event. Zwei unterschiedliche Modelle: ein entzückendes Kettenkarussell, das Platz für 5 Kinder bietet und ein Tierkarussell für 7 Kinder.",
      information: [
        { id: 1, title: "Größe", value: "" },
        { id: 2, title: "Strombedarf", value: "" },
        {
          id: 3,
          title: "Preis",
          value:
            "ab 250 € zzgl. Anlieferung / Abholung // ca. 410,00 € inkl. MwSt.",
        },
      ],
      price: 150,
    },

    {
      id: 2,
      state: false,
      title: "Hüpfburg",
      img: "../images/fahrgeschaefte/huepfburg.png",
      text:
        "Sommerfeste, Kindergeburtstage oder ein Straßenfest steht an? Da ist unsere kunterbunte Hüpfburg genau das Richtige! Ein unvergessliches Erlebnis an der frischen Luft.",
      information: [
        { id: 1, title: "Größe", value: "" },
        { id: 2, title: "Strombedarf", value: "" },
        { id: 3, title: "Preis", value: "" },
      ],
      price: 150,
    },

    {
      id: 3,
      state: false,
      title: "Popcornmaschine",
      img: "../images/fahrgeschaefte/popcornmaschine.png",
      text:
        "Frisch zubereitetes Popcorn riecht und schmeckt einfach köstlich! Entweder nehmen sie selbst die Maiskörner in die Hand oder unser freundlicher MitarbeiterIn bedient die Popcorn-Maschine. Egal bei welcher Veranstaltung, frisches Popcorn gehört zu den Klassikern die sich großer Beliebtheit bei Jung und Alt erfreuen.",
      information: [
        { id: 1, title: "Größe", value: "Tisch 100 x 100 cm" },
        { id: 2, title: "Strombedarf", value: "230 Volt / 16 A" },
        { id: 3, title: "Kapazität", value: "60 Portionen / Std" },
        { id: 4, title: "Preis", value: "ab 70,00 € inkl. MwSt" },
      ],
      price: 150,
    },

    {
      id: 4,
      state: false,
      title: "Zirkuszelt",
      img: "../images/fahrgeschaefte/zirkuszelt.png",
      text:
        "Unsere Zirkuszelte verleihen ihrer Veranstaltung einen ganz besonderen Flair. Sie können zwischen einem Festzelt, dem klassischen Zirkuszelt mit zwei Masten bis hin zur großflächigen Zirkuslandschaft auswählen. Ob für ihre Hochzeit, das Firmenevent oder ein Sommerfest, das Chapiteau ist für jegliche Eventform geeignet. Unsere Zelte haben unterschiedliche Maße, beginnend mit einem Durchmesser von 19 Meter können Sie zwischen einer Fläche ab 100 qm bis 2500 qm auswählen.",
      information: [
        { id: 1, title: "Größe", value: "" },
        { id: 2, title: "Strombedarf", value: "" },
        { id: 3, title: "Kapazität", value: "" },
        { id: 4, title: "Preis", value: "ab 70,00 € inkl. MwSt" },
      ],
      price: 150,
    },

    {
      id: 5,
      state: false,
      title: "Foodtruck",
      img: "../images/fahrgeschaefte/foodtruck.png",
      text:
        "Ob Firmenevent, Hochzeit, Familienfeier, Festival oder Messen, mit unserer stylisch ausgestatteten Küche auf vier Rädern servieren wir ihren Gästen frischzubereitetes Streetfood ganz nach ihrem Geschmack. Sie möchten selbst am Herd stehen? Gar kein Problem sie können den Foodtruck auch ohne MitarbeiterInnen buchen.",
      information: [
        { id: 1, title: "Größe", value: "" },
        { id: 2, title: "Strombedarf", value: "" },
        { id: 3, title: "Kapazität", value: "" },
        { id: 4, title: "Preis", value: "ab 500,00 € inkl. MwSt." },
      ],
      price: 150,
    },

    {
      id: 6,
      state: false,
      title: "Riesenrad",
      img: "../images/fahrgeschaefte/riesenrad.png",
      text:
        "Ein nostalgisches Riesenrad ist zu jeder Jahreszeit ein Hingucker. Bringen sie Kinderaugen zum Strahlen!",
      information: [
        { id: 1, title: "Größe", value: "" },
        { id: 2, title: "Strombedarf", value: "" },
        { id: 3, title: "Preis", value: "" },
      ],
      price: 150,
    },

    {
      id: 7,
      state: false,
      title: "Fotobox",
      img: "../images/fahrgeschaefte/fotobox.png",
      text:
        "Ein Schnappschuss zur Erinnerung an einen außergewöhnlichen Abend mit Freunden, Familie oder Kollegen. Mit der Fotobox hat jeder Gast die Möglichkeit eine Erinnerung mit nach Hause zu nehmen und den ultimativen Spaßfaktor bei Gruppenfotos mit Freunden zu erleben!",
      information: [
        {
          id: 1,
          title: "Maße",
          value: "(L B/H): ca. 100 x 150 x 200 cm / Dach steht ca. 10 cm über",
        },
        { id: 2, title: "Strombedarf", value: "220 Volt" },
        {
          id: 3,
          title: "Kapazität",
          value:
            "Ausgelegt ist die Fotokabine auf 4 Personen. Mit etwas Kreativität und Einsatz lässt sich das ohne Probleme ausweiten.",
        },
        {
          id: 4,
          title: "Preis",
          value:
            "ab 599 € inklusive lustiger Accessoires, Foto-Flatrate und Online-Galerie",
        },
      ],
      price: 150,
    },

    {
      id: 8,
      state: false,
      title: "Kinderschminken",
      img: "../images/fahrgeschaefte/kinderschminken.png",
      text:
        "Was wäre ein Kinderfest ohne bemalte Gesichter – wer erinnert sich nicht gern wie man als Löwe oder Schmetterling übers Sommerfest gewuselt ist. Als eine schöne Ergänzung zur Ausrichtung eines Jahrmarktes bieten wir Ihnen einen Stand mit Kinderschminken inkl. pädagogischer Betreuung.",
      information: [
        {
          id: 1,
          title: "Preis",
          value:
            "Diese Dienstleitung kann nur in Kombination mit der Anmietung von Attraktionen gebucht werden.",
        },
      ],
      price: 150,
    },

    {
      id: 9,
      state: false,
      title: "Schiffsbar",
      img: "../images/fahrgeschaefte/schiffsbar.png",
      text:
        "Diese Outdoor-Bar ist genau das Richtige für jede Veranstaltung ob Sommer oder Winter. Ob sie Glühwein, Bier oder Longdrinks servieren wollen – in der Schiffsbar sind alle Einbauten vorhanden. Selbstverständlich können Sie die Schiffsbar auch mit unserem freundlichen ServicemitarbeiterInnen buchen!",
      information: [
        { id: 1, title: "Maße", value: "" },
        { id: 2, title: "Stellfläche", value: "" },
        { id: 3, title: "Gewicht", value: "" },
        { id: 4, title: "Strombedarf", value: "" },
        { id: 5, title: "Kapazität", value: "" },
        { id: 6, title: "Preis", value: "" },
      ],
      price: 150,
    },

    {
      id: 10,
      state: false,
      title: "Kaffeewagen",
      img: "../images/fahrgeschaefte/kaffeewagen.png",
      text: "",
      information: [
        { id: 1, title: "Maße", value: "(L/B/H): 260 x 140 x 160" },
        { id: 2, title: "Stellfläche", value: "(L/B/H): 300 x 200 x 200" },
        { id: 3, title: "Stromversorgung", value: "1 x 230 Volt" },
        { id: 4, title: "Gewicht", value: "ca. 250 kg" },
        { id: 5, title: "Preis", value: "ab 500,00 €" },
      ],
      price: 150,
    },

    {
      id: 11,
      state: false,
      title: "Rodelbahn",
      img: "../images/fahrgeschaefte/schlittenbahn.jpg",
      text: "",
      information: [
        { id: 1, title: "Maße", value: "(L/B/H): ca. 600 x 250 x 340 cm" },
        { id: 2, title: "Gewicht", value: "1850 kg" },
        { id: 3, title: "Gesamtlänge", value: "25 Meter" },
        { id: 4, title: "Preis", value: "" },
      ],
      price: 150,
    },

    {
      id: 12,
      state: false,
      title: "Glücksrad",
      img: "../images/fahrgeschaefte/gluecksrad.png",
      text:
        "Es gibt was zu gewinnen – das Glücksrad ist ein bewährter Publikumsmagnet. Das Glücksrad, welches auf die älteste Gameshow der Welt zurück geht, ist ein Unterhaltungsgarant auf jedem Firmenevent, Straßenfest oder rauschendem Galadinner.",
      information: [
        {
          id: 1,
          title: "Preis",
          value:
            "Diese Dienstleitung kann nur in Kombination mit der Anmietung von Attraktionen gebucht werden.",
        },
      ],
      price: 150,
    },
  ],
}
